import React from "react";
import logo from "../assests/logo_large.svg";
import { SchedulePost } from "../components/btn/SchedulePost";
import Topbar from "../components/Topbar";
import GalleryPreview from "../components/GalleryPreview";
import Reviews from "../components/Reviews";

const Home = () => {
  return (
    <div>
      {/* Topbar */}
      <Topbar />
      <div className="py-1 text-center text-white bg-primary underline font-bold">
        <a 
          href="https://calendly.com/hello-lumor/complimentary-photoshoot"
          target="_blank"
        >
          <p>GET YOUR FIRST PHOTOSHOOT FREE</p>
        </a>
       
      </div>
      <div className="container mx-auto py-4 md:py-6 grid grid-cols-1 gap-8"> {/* Reduced padding and gap */}
        <div className="grid grid-cols-1 gap-2"> {/* Further reduced gap */}
          <h1 className="delius-regular text-textPrimary font-bold text-[1.55rem] md:text-4xl text-left md:text-center max-w-5xl mx-auto">
            Dating App Photography | Lumor Studio 
          </h1>
          <hr className="border border-boderLight opacity-55" />
          <p className="delius-regular mt-10 text-textSecondary text-lg text-left md:text-center max-w-2xl mx-auto font-normal mb-0">
          Hey there 👋... this is Lumor Studio.
          We’re a portrait photography studio in San Francisco, serving the Bay Area. We are here to bring your dating app profile to life. 
          Our photos are <b>high quality</b>, have <b>natural lighting</b> and feel <b>authentic</b>—just like a friend took them. 
          We shoot at vibrant city spots to keep things fun and easy-going.
          </p>

          <p className="delius-regular mt-10 text-textSecondary text-lg text-left md:text-center max-w-2xl mx-auto font-normal mb-0">
          Whether this is your first photoshoot or your 100th, we’ve got you covered. We’ll guide you every step of the way - 
          from outfit suggestions before the shoot to helping select the final five pictures after the shoot.
          </p>
          <p className="delius-regular text-textSecondary text-lg text-left md:text-center max-w-2xl mx-auto font-normal mt-5">
          We respect your <b>privacy</b> and <b>discretion</b>. None of your photos will be posted on our website or social media without your written consent.
          </p>
          <p className="delius-regular text-textSecondary text-lg text-left md:text-center max-w-2xl mx-auto font-normal mt-5">
            We turn everyday profiles into absolute swipe-rights! Let us make your profile stand out. 📸
          </p>
        </div>

        <SchedulePost /> {/* Button component */}
        <hr className="border border-boderLight opacity-55" />
        <GalleryPreview />
      </div>
      {/* <Reviews /> */}
    </div>
  );
};


export default Home;
